export const colors = {
    black: '#000000',
    white: '#ffffff',
    lightgrey: '#8d8c8c',
    orange: '#ef6c00',
    grey: '#d7d7d7',
    darkgray: '#8d8c8c',
    contextgrey: '#4c4b4b',
    blue: '#283593',
    menuBurgerBlue: '#2b3191',
    lightblue: '#5674b9',
    inputgrey: '#b7b7b7',
    red: '#ff0000',
    responsiveMenuBorder: '#e1e1e1'
}